// eslint-disable-next-line @nx/enforce-module-boundaries
import { AgentsPage } from '@insurance/features/staff/pages'
import { useParams } from 'react-router-dom'

export const AgentsStaffPage = () => {
  const { id } = useParams()

  return <AgentsPage brokerId={id} />
}
